/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SupportRouteImport } from './routes/support'
import { Route as ShipmentsRouteImport } from './routes/shipments'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SalesOrdersRouteImport } from './routes/sales-orders'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as CustomersDashboardRouteImport } from './routes/customers-dashboard'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as AddressbookRouteImport } from './routes/addressbook'
import { Route as AccountDeletionRouteImport } from './routes/account-deletion'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as SsoHandoffRouteImport } from './routes/sso/handoff'
import { Route as FleetVehiclesRouteImport } from './routes/fleet/vehicles'
import { Route as FleetResourcesRouteImport } from './routes/fleet/resources'
import { Route as FleetDriversRouteImport } from './routes/fleet/drivers'
import { Route as FinanceTransactionsRouteImport } from './routes/finance/transactions'
import { Route as FinanceStatementRouteImport } from './routes/finance/statement'
import { Route as FinancePaymentsRouteImport } from './routes/finance/payments'
import { Route as FinanceInvoicesRouteImport } from './routes/finance/invoices'
import { Route as DnTokenRouteImport } from './routes/dn.$token'
import { Route as DTokenRouteImport } from './routes/d.$token'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminTenantsRouteImport } from './routes/admin/tenants'
import { Route as AdminRegionsRouteImport } from './routes/admin/regions'
import { Route as AdminProductsRouteImport } from './routes/admin/products'
import { Route as AdminFactoriesRouteImport } from './routes/admin/factories'
import { Route as AdminCustomerAccountsRouteImport } from './routes/admin/customer-accounts'
import { Route as AdminCitiesRouteImport } from './routes/admin/cities'
import { Route as AdminAvailabilityRouteImport } from './routes/admin/availability'

const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const ShipmentsRoute = ShipmentsRouteImport.update({
  id: '/shipments',
  path: '/shipments',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesOrdersRoute = SalesOrdersRouteImport.update({
  id: '/sales-orders',
  path: '/sales-orders',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersDashboardRoute = CustomersDashboardRouteImport.update({
  id: '/customers-dashboard',
  path: '/customers-dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersRoute = CustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const AddressbookRoute = AddressbookRouteImport.update({
  id: '/addressbook',
  path: '/addressbook',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountDeletionRoute = AccountDeletionRouteImport.update({
  id: '/account-deletion',
  path: '/account-deletion',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoHandoffRoute = SsoHandoffRouteImport.update({
  id: '/sso/handoff',
  path: '/sso/handoff',
  getParentRoute: () => rootRouteImport,
} as any)
const FleetVehiclesRoute = FleetVehiclesRouteImport.update({
  id: '/fleet/vehicles',
  path: '/fleet/vehicles',
  getParentRoute: () => rootRouteImport,
} as any)
const FleetResourcesRoute = FleetResourcesRouteImport.update({
  id: '/fleet/resources',
  path: '/fleet/resources',
  getParentRoute: () => rootRouteImport,
} as any)
const FleetDriversRoute = FleetDriversRouteImport.update({
  id: '/fleet/drivers',
  path: '/fleet/drivers',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceTransactionsRoute = FinanceTransactionsRouteImport.update({
  id: '/finance/transactions',
  path: '/finance/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceStatementRoute = FinanceStatementRouteImport.update({
  id: '/finance/statement',
  path: '/finance/statement',
  getParentRoute: () => rootRouteImport,
} as any)
const FinancePaymentsRoute = FinancePaymentsRouteImport.update({
  id: '/finance/payments',
  path: '/finance/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceInvoicesRoute = FinanceInvoicesRouteImport.update({
  id: '/finance/invoices',
  path: '/finance/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const DnTokenRoute = DnTokenRouteImport.update({
  id: '/dn/$token',
  path: '/dn/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DTokenRoute = DTokenRouteImport.update({
  id: '/d/$token',
  path: '/d/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTenantsRoute = AdminTenantsRouteImport.update({
  id: '/admin/tenants',
  path: '/admin/tenants',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRegionsRoute = AdminRegionsRouteImport.update({
  id: '/admin/regions',
  path: '/admin/regions',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminProductsRoute = AdminProductsRouteImport.update({
  id: '/admin/products',
  path: '/admin/products',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFactoriesRoute = AdminFactoriesRouteImport.update({
  id: '/admin/factories',
  path: '/admin/factories',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCustomerAccountsRoute = AdminCustomerAccountsRouteImport.update({
  id: '/admin/customer-accounts',
  path: '/admin/customer-accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCitiesRoute = AdminCitiesRouteImport.update({
  id: '/admin/cities',
  path: '/admin/cities',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAvailabilityRoute = AdminAvailabilityRouteImport.update({
  id: '/admin/availability',
  path: '/admin/availability',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/account-deletion': typeof AccountDeletionRoute
  '/addressbook': typeof AddressbookRoute
  '/customers': typeof CustomersRoute
  '/customers-dashboard': typeof CustomersDashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/orders': typeof OrdersRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sales-orders': typeof SalesOrdersRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/shipments': typeof ShipmentsRoute
  '/support': typeof SupportRoute
  '/admin/availability': typeof AdminAvailabilityRoute
  '/admin/cities': typeof AdminCitiesRoute
  '/admin/customer-accounts': typeof AdminCustomerAccountsRoute
  '/admin/factories': typeof AdminFactoriesRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/regions': typeof AdminRegionsRoute
  '/admin/tenants': typeof AdminTenantsRoute
  '/admin/users': typeof AdminUsersRoute
  '/d/$token': typeof DTokenRoute
  '/dn/$token': typeof DnTokenRoute
  '/finance/invoices': typeof FinanceInvoicesRoute
  '/finance/payments': typeof FinancePaymentsRoute
  '/finance/statement': typeof FinanceStatementRoute
  '/finance/transactions': typeof FinanceTransactionsRoute
  '/fleet/drivers': typeof FleetDriversRoute
  '/fleet/resources': typeof FleetResourcesRoute
  '/fleet/vehicles': typeof FleetVehiclesRoute
  '/sso/handoff': typeof SsoHandoffRoute
  '/admin': typeof AdminIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/account-deletion': typeof AccountDeletionRoute
  '/addressbook': typeof AddressbookRoute
  '/customers': typeof CustomersRoute
  '/customers-dashboard': typeof CustomersDashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/orders': typeof OrdersRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sales-orders': typeof SalesOrdersRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/shipments': typeof ShipmentsRoute
  '/support': typeof SupportRoute
  '/admin/availability': typeof AdminAvailabilityRoute
  '/admin/cities': typeof AdminCitiesRoute
  '/admin/customer-accounts': typeof AdminCustomerAccountsRoute
  '/admin/factories': typeof AdminFactoriesRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/regions': typeof AdminRegionsRoute
  '/admin/tenants': typeof AdminTenantsRoute
  '/admin/users': typeof AdminUsersRoute
  '/d/$token': typeof DTokenRoute
  '/dn/$token': typeof DnTokenRoute
  '/finance/invoices': typeof FinanceInvoicesRoute
  '/finance/payments': typeof FinancePaymentsRoute
  '/finance/statement': typeof FinanceStatementRoute
  '/finance/transactions': typeof FinanceTransactionsRoute
  '/fleet/drivers': typeof FleetDriversRoute
  '/fleet/resources': typeof FleetResourcesRoute
  '/fleet/vehicles': typeof FleetVehiclesRoute
  '/sso/handoff': typeof SsoHandoffRoute
  '/admin': typeof AdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/account-deletion': typeof AccountDeletionRoute
  '/addressbook': typeof AddressbookRoute
  '/customers': typeof CustomersRoute
  '/customers-dashboard': typeof CustomersDashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/orders': typeof OrdersRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sales-orders': typeof SalesOrdersRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/shipments': typeof ShipmentsRoute
  '/support': typeof SupportRoute
  '/admin/availability': typeof AdminAvailabilityRoute
  '/admin/cities': typeof AdminCitiesRoute
  '/admin/customer-accounts': typeof AdminCustomerAccountsRoute
  '/admin/factories': typeof AdminFactoriesRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/regions': typeof AdminRegionsRoute
  '/admin/tenants': typeof AdminTenantsRoute
  '/admin/users': typeof AdminUsersRoute
  '/d/$token': typeof DTokenRoute
  '/dn/$token': typeof DnTokenRoute
  '/finance/invoices': typeof FinanceInvoicesRoute
  '/finance/payments': typeof FinancePaymentsRoute
  '/finance/statement': typeof FinanceStatementRoute
  '/finance/transactions': typeof FinanceTransactionsRoute
  '/fleet/drivers': typeof FleetDriversRoute
  '/fleet/resources': typeof FleetResourcesRoute
  '/fleet/vehicles': typeof FleetVehiclesRoute
  '/sso/handoff': typeof SsoHandoffRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/account-deletion'
    | '/addressbook'
    | '/customers'
    | '/customers-dashboard'
    | '/forgot-password'
    | '/login'
    | '/orders'
    | '/privacy-policy'
    | '/register'
    | '/reset-password'
    | '/sales-orders'
    | '/search'
    | '/settings'
    | '/shipments'
    | '/support'
    | '/admin/availability'
    | '/admin/cities'
    | '/admin/customer-accounts'
    | '/admin/factories'
    | '/admin/products'
    | '/admin/regions'
    | '/admin/tenants'
    | '/admin/users'
    | '/d/$token'
    | '/dn/$token'
    | '/finance/invoices'
    | '/finance/payments'
    | '/finance/statement'
    | '/finance/transactions'
    | '/fleet/drivers'
    | '/fleet/resources'
    | '/fleet/vehicles'
    | '/sso/handoff'
    | '/admin'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/account-deletion'
    | '/addressbook'
    | '/customers'
    | '/customers-dashboard'
    | '/forgot-password'
    | '/login'
    | '/orders'
    | '/privacy-policy'
    | '/register'
    | '/reset-password'
    | '/sales-orders'
    | '/search'
    | '/settings'
    | '/shipments'
    | '/support'
    | '/admin/availability'
    | '/admin/cities'
    | '/admin/customer-accounts'
    | '/admin/factories'
    | '/admin/products'
    | '/admin/regions'
    | '/admin/tenants'
    | '/admin/users'
    | '/d/$token'
    | '/dn/$token'
    | '/finance/invoices'
    | '/finance/payments'
    | '/finance/statement'
    | '/finance/transactions'
    | '/fleet/drivers'
    | '/fleet/resources'
    | '/fleet/vehicles'
    | '/sso/handoff'
    | '/admin'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/account-deletion'
    | '/addressbook'
    | '/customers'
    | '/customers-dashboard'
    | '/forgot-password'
    | '/login'
    | '/orders'
    | '/privacy-policy'
    | '/register'
    | '/reset-password'
    | '/sales-orders'
    | '/search'
    | '/settings'
    | '/shipments'
    | '/support'
    | '/admin/availability'
    | '/admin/cities'
    | '/admin/customer-accounts'
    | '/admin/factories'
    | '/admin/products'
    | '/admin/regions'
    | '/admin/tenants'
    | '/admin/users'
    | '/d/$token'
    | '/dn/$token'
    | '/finance/invoices'
    | '/finance/payments'
    | '/finance/statement'
    | '/finance/transactions'
    | '/fleet/drivers'
    | '/fleet/resources'
    | '/fleet/vehicles'
    | '/sso/handoff'
    | '/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  AccountDeletionRoute: typeof AccountDeletionRoute
  AddressbookRoute: typeof AddressbookRoute
  CustomersRoute: typeof CustomersRoute
  CustomersDashboardRoute: typeof CustomersDashboardRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  OrdersRoute: typeof OrdersRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SalesOrdersRoute: typeof SalesOrdersRoute
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRoute
  ShipmentsRoute: typeof ShipmentsRoute
  SupportRoute: typeof SupportRoute
  AdminAvailabilityRoute: typeof AdminAvailabilityRoute
  AdminCitiesRoute: typeof AdminCitiesRoute
  AdminCustomerAccountsRoute: typeof AdminCustomerAccountsRoute
  AdminFactoriesRoute: typeof AdminFactoriesRoute
  AdminProductsRoute: typeof AdminProductsRoute
  AdminRegionsRoute: typeof AdminRegionsRoute
  AdminTenantsRoute: typeof AdminTenantsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  DTokenRoute: typeof DTokenRoute
  DnTokenRoute: typeof DnTokenRoute
  FinanceInvoicesRoute: typeof FinanceInvoicesRoute
  FinancePaymentsRoute: typeof FinancePaymentsRoute
  FinanceStatementRoute: typeof FinanceStatementRoute
  FinanceTransactionsRoute: typeof FinanceTransactionsRoute
  FleetDriversRoute: typeof FleetDriversRoute
  FleetResourcesRoute: typeof FleetResourcesRoute
  FleetVehiclesRoute: typeof FleetVehiclesRoute
  SsoHandoffRoute: typeof SsoHandoffRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shipments': {
      id: '/shipments'
      path: '/shipments'
      fullPath: '/shipments'
      preLoaderRoute: typeof ShipmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-orders': {
      id: '/sales-orders'
      path: '/sales-orders'
      fullPath: '/sales-orders'
      preLoaderRoute: typeof SalesOrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers-dashboard': {
      id: '/customers-dashboard'
      path: '/customers-dashboard'
      fullPath: '/customers-dashboard'
      preLoaderRoute: typeof CustomersDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers': {
      id: '/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof CustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/addressbook': {
      id: '/addressbook'
      path: '/addressbook'
      fullPath: '/addressbook'
      preLoaderRoute: typeof AddressbookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-deletion': {
      id: '/account-deletion'
      path: '/account-deletion'
      fullPath: '/account-deletion'
      preLoaderRoute: typeof AccountDeletionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso/handoff': {
      id: '/sso/handoff'
      path: '/sso/handoff'
      fullPath: '/sso/handoff'
      preLoaderRoute: typeof SsoHandoffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fleet/vehicles': {
      id: '/fleet/vehicles'
      path: '/fleet/vehicles'
      fullPath: '/fleet/vehicles'
      preLoaderRoute: typeof FleetVehiclesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fleet/resources': {
      id: '/fleet/resources'
      path: '/fleet/resources'
      fullPath: '/fleet/resources'
      preLoaderRoute: typeof FleetResourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fleet/drivers': {
      id: '/fleet/drivers'
      path: '/fleet/drivers'
      fullPath: '/fleet/drivers'
      preLoaderRoute: typeof FleetDriversRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/transactions': {
      id: '/finance/transactions'
      path: '/finance/transactions'
      fullPath: '/finance/transactions'
      preLoaderRoute: typeof FinanceTransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/statement': {
      id: '/finance/statement'
      path: '/finance/statement'
      fullPath: '/finance/statement'
      preLoaderRoute: typeof FinanceStatementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/payments': {
      id: '/finance/payments'
      path: '/finance/payments'
      fullPath: '/finance/payments'
      preLoaderRoute: typeof FinancePaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/invoices': {
      id: '/finance/invoices'
      path: '/finance/invoices'
      fullPath: '/finance/invoices'
      preLoaderRoute: typeof FinanceInvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dn/$token': {
      id: '/dn/$token'
      path: '/dn/$token'
      fullPath: '/dn/$token'
      preLoaderRoute: typeof DnTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/d/$token': {
      id: '/d/$token'
      path: '/d/$token'
      fullPath: '/d/$token'
      preLoaderRoute: typeof DTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tenants': {
      id: '/admin/tenants'
      path: '/admin/tenants'
      fullPath: '/admin/tenants'
      preLoaderRoute: typeof AdminTenantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/regions': {
      id: '/admin/regions'
      path: '/admin/regions'
      fullPath: '/admin/regions'
      preLoaderRoute: typeof AdminRegionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/products': {
      id: '/admin/products'
      path: '/admin/products'
      fullPath: '/admin/products'
      preLoaderRoute: typeof AdminProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/factories': {
      id: '/admin/factories'
      path: '/admin/factories'
      fullPath: '/admin/factories'
      preLoaderRoute: typeof AdminFactoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/customer-accounts': {
      id: '/admin/customer-accounts'
      path: '/admin/customer-accounts'
      fullPath: '/admin/customer-accounts'
      preLoaderRoute: typeof AdminCustomerAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/cities': {
      id: '/admin/cities'
      path: '/admin/cities'
      fullPath: '/admin/cities'
      preLoaderRoute: typeof AdminCitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/availability': {
      id: '/admin/availability'
      path: '/admin/availability'
      fullPath: '/admin/availability'
      preLoaderRoute: typeof AdminAvailabilityRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  AccountDeletionRoute: AccountDeletionRoute,
  AddressbookRoute: AddressbookRoute,
  CustomersRoute: CustomersRoute,
  CustomersDashboardRoute: CustomersDashboardRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  OrdersRoute: OrdersRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SalesOrdersRoute: SalesOrdersRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRoute,
  ShipmentsRoute: ShipmentsRoute,
  SupportRoute: SupportRoute,
  AdminAvailabilityRoute: AdminAvailabilityRoute,
  AdminCitiesRoute: AdminCitiesRoute,
  AdminCustomerAccountsRoute: AdminCustomerAccountsRoute,
  AdminFactoriesRoute: AdminFactoriesRoute,
  AdminProductsRoute: AdminProductsRoute,
  AdminRegionsRoute: AdminRegionsRoute,
  AdminTenantsRoute: AdminTenantsRoute,
  AdminUsersRoute: AdminUsersRoute,
  DTokenRoute: DTokenRoute,
  DnTokenRoute: DnTokenRoute,
  FinanceInvoicesRoute: FinanceInvoicesRoute,
  FinancePaymentsRoute: FinancePaymentsRoute,
  FinanceStatementRoute: FinanceStatementRoute,
  FinanceTransactionsRoute: FinanceTransactionsRoute,
  FleetDriversRoute: FleetDriversRoute,
  FleetResourcesRoute: FleetResourcesRoute,
  FleetVehiclesRoute: FleetVehiclesRoute,
  SsoHandoffRoute: SsoHandoffRoute,
  AdminIndexRoute: AdminIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
